import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import { ReactReduxFirebaseProvider } from 'react-redux-firebase';
import { createFirestoreInstance } from 'redux-firestore';
import { ThemeProvider } from 'styled-components';
import '@fontsource/manrope/400.css';
import '@fontsource/manrope/500.css';
import '@fontsource/manrope/600.css';
import '@fontsource/manrope/700.css';
import '@fontsource/manrope/800.css';
import 'react-toastify/dist/ReactToastify.css';

import App from './App';
import firebase from './Firebase/Firebase';
import store, { rrfConfig } from './Store';
import theme from './Utils/theme';
import GlobalStyles from './Utils/global';
import './index.css';
import { I18nProvider } from './i18n/I18nProvider';

const root = document.getElementById('root');

const rrfProps = {
  firebase,
  config: rrfConfig,
  dispatch: store.dispatch,
  createFirestoreInstance,
};

ReactDOM.render(
  <ThemeProvider theme={theme}>
    <GlobalStyles />
    <Provider store={store}>
      <ReactReduxFirebaseProvider {...rrfProps}>
        <I18nProvider>
          <Router>
            <App />
          </Router>
        </I18nProvider>
      </ReactReduxFirebaseProvider>
    </Provider>
  </ThemeProvider>,
  root,
);
